/**
 * PDF1 Slide 4 - Registro de Ocorrências
 * Endpoint: /api/v1/visitas/dashboards/ocorrencias/
 * 
 * Filtros: ANO apenas
 */
import { useState, useEffect } from "react";
import { Card, Row, Col, Spinner, Alert, Badge } from "react-bootstrap";
import { ResponsiveBar } from "@nivo/bar";
import api from "../../../services/api";
import { traduzirMesesEmDados } from "./utils/mesesUtils";

const Slide4RegistroOcorrencias = ({ programaId, filters }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const ano = filters?.year || new Date().getFullYear();

  useEffect(() => {
    api.get(`/visitas/dashboards/ocorrencias/?programa_id=${programaId}&ano=${ano}`)
      .then(res => {
        if (res.data) {
          setData(res.data);
        } else {
          setData({ ocorrencias_mensal: [] });
        }
      })
      .catch((err) => {
        console.error('[Slide4] API error:', err.response?.data || err.message);
        setError(err.response?.data?.error || err.message);
      })
      .finally(() => setLoading(false));
  }, [programaId, ano]);

  const labelAno = `Ano: ${ano}`;

  if (loading) return <Spinner animation="border" className="d-block mx-auto my-4" />;

  if (error) {
    return (
      <Alert variant="warning" className="m-3">
        <strong>Seção 3 - Registro de Ocorrências:</strong> {error}
      </Alert>
    );
  }

  const ocorrenciasArr = Array.isArray(data?.ocorrencias_mensal) ? data.ocorrencias_mensal : [];
  if (data && (data.ocorrencias_mensal !== undefined && !Array.isArray(data.ocorrencias_mensal))) {
    console.warn('[Slide4] ocorrencias_mensal não é array:', data.ocorrencias_mensal);
  }
  const hasOcorrencias = ocorrenciasArr.length > 0;

  const ocorrenciasTraduzidas = traduzirMesesEmDados(ocorrenciasArr);

  return (
    <Row>
      <Col md={12} className="mb-4">
        <Card className="h-100 border-0 shadow-sm">
          <Card.Header className="bg-white fw-bold border-0 d-flex justify-content-between align-items-center" style={{ color: "#ed7d31" }}>
            <span>Tentativas de Contato sem Retorno</span>
            <Badge bg="secondary" className="fw-normal">{labelAno}</Badge>
          </Card.Header>
          <Card.Body style={{ height: "300px" }}>
            {hasOcorrencias ? (
              <ResponsiveBar
                data={ocorrenciasTraduzidas}
                keys={["tentativas"]}
                indexBy="mes"
                margin={{ top: 20, right: 20, bottom: 40, left: 50 }}
                padding={0.4}
                colors={["#ed7d31"]}
                labelTextColor="#fff"
                axisBottom={{ tickSize: 0, tickPadding: 10 }}
                axisLeft={{ tickSize: 0, tickPadding: 10 }}
                enableGridY={true}
              />
            ) : (
              <div className="d-flex align-items-center justify-content-center h-100">
                <span className="text-muted">Sem registros disponíveis</span>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Slide4RegistroOcorrencias;
